const FEATURE_FLAGS = {
  USE_NEW_SCROLL_ENGINE: true,
  USE_DELTA_SYNC: false,
  USE_CRDT_ENGINE: true,
  USE_MESSAGE_GRAPH: true,
} as const;

export default FEATURE_FLAGS;
